import {
  Avatar,
  Box,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import React, { Fragment, useState } from "react";

import LanguageHolder from "./Reusable/LanguageHolder";
import { Logout } from "@mui/icons-material";
import NotificationHolder from "./Reusable/NotificationHolder";
import SettingsIcon from "@mui/icons-material/Settings";
import { logout } from "../../actions/security";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getInitials } from "../../utils";

const MenuAccountSettings = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutFunction = () => {
    dispatch(logout(navigate));
  };

  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);

  const userData = loggedUserReducer?.loggedUser;

  return (
    <Fragment>
      {/* <NotificationHolder /> */}
      <LanguageHolder />
      <Box className="box-user-settings d-flex align-items-center text-center">
        <Tooltip title="Account settings">
          <div
            onClick={handleClick}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            className="account-settings-item"
          >
            <Avatar sx={{ width: 35, height: 35, fontSize: 15 }}>
              {getInitials(userData?.name + " " + userData?.lastName)}
            </Avatar>
            <div className="account-settings-list-items">
              <span className="account-settings-fullname">
                {userData?.name} {userData?.lastName}
              </span>
              <span className="account-settings-email">{userData?.email}</span>
            </div>
          </div>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* <MenuItem component={Link}>
          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          Moj profil
        </MenuItem> */}
        {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={logoutFunction}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t("global.logout")}
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

export default MenuAccountSettings;
